/**
 * Created: 2024-03-27
 * Last Updated: 2024-03-27
 *
 * FlagsmithUserIdentifier Component
 * A client-side component that handles user identification in Flagsmith
 *
 * Changes:
 * - Added 'use client' directive for Next.js 13+ compatibility
 * - Added proper component documentation
 * - Uses Jotai for state management
 */

'use client'

import {useAtomValue} from 'jotai'
import type {Atom} from 'jotai'
import {useEffect, useState} from 'react'
import {IFlagsmith} from 'flagsmith/types'

// eslint-disable-next-line react/prop-types
export const FlagsmithUserIdentifier: React.FC<FlagsmithUserIdentifierProps> = ({flagsmith, currentUserState}) => {
  const currentUser = useAtomValue(currentUserState)
  const [flagsUpdated, setFlagsUpdated] = useState(false)

  useEffect(() => {
    if (currentUser?.email) {
      flagsmith
        // eslint-disable-next-line react/prop-types
        .identify(currentUser.email)
        .then(async () => {
          // Flags are reloaded after identification
          // eslint-disable-next-line react/prop-types
          await flagsmith.getFlags()
          setFlagsUpdated(true) // Trigger a re-render
        })
        .catch((error) => console.error('Error identifying user in Flagsmith:', error))
    }
  }, [currentUser, flagsmith])

  // Optionally, you can display a loading state while flags are updating
  if (!flagsUpdated) {
    return null
  }

  return null
}

interface CurrentUser {
  email: string
}

interface FlagsmithUserIdentifierProps {
  flagsmith: IFlagsmith
  currentUserState: Atom<CurrentUser | null>
}
